<template lang="pug">
.relative
  v-overlay.filter-blur-1.rounded-16(
    v-if="loading"
    absolute
    color="redesignBackground"
    opacity="0.2"
    :z-index="10"
  )
    v-progress-circular(
      color="redesignPrimary"
      indeterminate
    )
  div
    .d-flex.justify-space-between.gap-32.flex-wrap
      div
        .relative.fit-content-height
          v-overlay.rounded-8(
            absolute
            :color="colorData.overlay"
            :z-index="10"
            opacity="1"
          )
            .title.weight-600.text-center.line-clamp-3.ma-4(
              :style="`color: ${colorData.text};`"
            ) {{ event.name }}
          v-img.rounded-8(
            :src="mainImage"
            :max-width="300"
          )
        .d-flex.mt-3.align-center.gap-8
          .body-2.weight-500.redesignPrimary--text Изменить цвет
          v-btn-toggle(v-model="activeOption" mandatory dense rounded)
            v-btn(:value="CHANGE_OPTIONS.TEXT" color="redesignPrimary" text) Текста
            v-btn(:value="CHANGE_OPTIONS.OVERLAY" color="redesignPrimary" text) Наложения
      v-color-picker.redesignBackground(
        v-model="currentItemModel"
        hide-inputs
        flat
      )
    .d-flex.pt-8.gap-16.px-2
      v-btn.px-7.rounded-12.body-1.flex-1(
        outlined
        large
        color="redesignPrimary"
        @click="closeDialog"
      ) Закрыть
      v-btn.px-7.rounded-12.white--text.ma-0.body-1.flex-1(
        :loading="loading"
        large
        color="redesignPrimary"
        @click="saveSettings"
      ) Сохранить
</template>

<script>
import AppButton from '@/components/user-redesign/controls/AppButton.vue';

const CHANGE_OPTIONS = {
  TEXT: 'text',
  OVERLAY: 'overlay',
};

export default {
  components: {
    AppButton,
  },

  props: {
    event: { type: Object, required: true },
  },

  data() {
    return {
      loading: false,
      CHANGE_OPTIONS,
      activeOption: CHANGE_OPTIONS.TEXT,
      colorData: {
        overlay: '',
        text: '',
      },
    };
  },

  computed: {
    mainImage() {
      const { thumb, url } = this.event.main_image;
      return thumb || url;
    },
    currentItemModel: {
      get() {
        return this.colorData[this.activeOption];
      },
      set(val) {
        this.colorData[this.activeOption] = val;
      },
    },
  },

  mounted() {
    this.getSettings();
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
    getSettings() {
      this.colorData = this.event.options.frontend_params.mainImageOverlayColor;
    },
    async saveSettings() {
      this.loading = true;
      const { frontend_params } = this.event.options;
      const params = {
        frontend_params: {
          ...frontend_params,
          image_overlay: this.colorData,
        },
      };
      const { error } = await this.event.updateOptions(params);
      if (!error) {
        this.$toast.success('Параметры наложения обновлены');
      }
      this.loading = false;
      this.closeDialog();
    },
  },
};
</script>
